import {PartnerDetailModelPartnerStatus} from './Enums';
import {ClientPartnerTagModel} from './ClientPartnerTagModel';

export class PartnerDetailModel implements IPartnerDetailModel {
  isActive?: boolean | undefined;
  partnerStatus?: PartnerDetailModelPartnerStatus | undefined;
  partnerTags?: ClientPartnerTagModel[] | undefined;
  partnerSummary?: string | undefined;
  partnerType?: string | undefined;

  constructor(data?: IPartnerDetailModel) {
    if (data) {
      for (var property in data) {
        if (data.hasOwnProperty(property))
          (<any>this)[property] = (<any>data)[property];
      }
    }
  }

  init(Data?: any) {
    if (Data) {
      this.isActive = Data["isActive"];
      this.partnerStatus = Data["partnerStatus"];
      if (Array.isArray(Data["partnerTags"])) {
        this.partnerTags = [] as any;
        for (let item of Data["partnerTags"])
          this.partnerTags!.push(ClientPartnerTagModel.fromJS(item));
      }
      this.partnerSummary = Data["partnerSummary"];
      this.partnerType = Data["partnerType"];
    }
  }

  static fromJS(data: any): PartnerDetailModel {
    data = typeof data === 'object' ? data : {};
    let result = new PartnerDetailModel();
    result.init(data);
    return result;
  }

  toJSON(data?: any) {
    data = typeof data === 'object' ? data : {};
    data["isActive"] = this.isActive;
    data["partnerStatus"] = this.partnerStatus;
    if (Array.isArray(this.partnerTags)) {
      data["partnerTags"] = [];
      for (let item of this.partnerTags)
        data["partnerTags"].push(item.toJSON());
    }
    data["partnerSummary"] = this.partnerSummary;
    data["partnerType"] = this.partnerType;
    return data;
  }
}

export interface IPartnerDetailModel {
  isActive?: boolean | undefined;
  partnerStatus?: PartnerDetailModelPartnerStatus | undefined;
  partnerTags?: ClientPartnerTagModel[] | undefined;
  partnerSummary?: string | undefined;
  partnerType?: string | undefined;
}